import React from 'react';

import CartSummary from '../../../resuable-ui/cart-summary';

import styles from './index.module.scss';
import { CartProps, PaymentProps } from '../../../../models';
import { getSession } from '../../../../utils/storage';

interface ISummary {
	data: CartProps & { payments?: PaymentProps[]; transactionId?: number };
}

const Summary = ({ data }: ISummary) => {
	const refCartId = data?._id;
	const overrides = refCartId ? (getSession(`price-overrides-${refCartId}`) as Record<string, number>) || {} : {};

	return (
		<>
			<div className={styles.summary}>
				<span>Summary</span>
			</div>
			<section className={`${styles.wrapper}`}>
				{(data?.products ?? []).map(({ productName, sellingPrice, productId, quantity }) => {
					const price = overrides[productId] ?? sellingPrice ?? 0;
					return (
						<CartSummary
							{...{
								name: productName,
								amount: price,
								quantity: quantity,
								id: productId,
							}}
						/>
					);
				})}
			</section>
		</>
	);
};

export default Summary;
